import { Box } from "@mui/system";
import DownloadButton from "../Common/DownloadButton";
import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";
import csv from '../../Data/MANCP/FoodProduct/MANCP-Quantified-results-per-Foodex-2-groups.csv'
import img from '../../Assets/dottedgraph.png';



const DottedGraphMobile = (props) => {
    const [csvData, setCSVData] = useState(undefined);
    const { readString } = usePapaParse();

    useEffect(() => {
        readString(csv, {
            complete: (results, file) => {
                setCSVData(results.data);
            },
            download: true,
            header: true,
            dynamicTyping: true,
            error: (error, file) => {
                console.log('Error while parsing:', error, file);
            },
        });
    }, []);
    return (

        <Box sx={{ maxWidth: '400px' }}>
            <Box display='flex' justifyContent='space-between'>
                <p style={{ fontFamily: 'Roboto Condensed, sans-serif', marginBottom: '1.1rem' }}>Quantified results per Foodex 2 groups</p>
                <DownloadButton csv={csvData} fileName='Quantified results per Foodex 2 groups' imageAsset={img} />
            </Box>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 327 690">
                <g transform="translate(-24 -10398)">
                    <g transform="translate(0 23.517)">
                        <g transform="translate(-73 -686.6)">
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(265 11736.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(217 11736.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(289 11736.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(241 11736.083)" fill="#77be7e" />
                        </g>
                        <text transform="translate(209 11039.483)" font-size="14" font-family="Roboto Condensed, sans-serif, Roboto">
                            <tspan x="-42.369" y="0">Sprat: 4</tspan>
                        </text>
                    </g>
                    <g transform="translate(0 21.517)">
                        <g transform="translate(-193 -709.6)">
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(313 11711.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(337 11711.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(265 11711.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(361 11711.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(289 11711.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(217 11711.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(241 11711.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(409 11711.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(481 11711.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(433 11711.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(505 11711.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(529 11711.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(385 11711.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(457 11711.083)" fill="#77be7e" />
                        </g>
                        <text transform="translate(223 10991.483)" font-size="14" fontFamily="Roboto Condensed, sans-serif, Roboto">
                            <tspan x="-70.383" y="0">Sea bass: 14</tspan>
                        </text>
                    </g>
                    <g transform="translate(153 -794.083)">
                        <g transform="translate(-202 81)">
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(217 11686.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(241 11686.083)" fill="#77be7e" />
                        </g>
                        <text transform="translate(65 11757.083)" font-size="14" fontFamily="Roboto Condensed, sans-serif, Roboto">
                            <tspan x="-61.264" y="0">Salmons: 2</tspan>
                        </text>
                    </g>
                    <g transform="translate(0 17.517)">
                        <g transform="translate(-49 -755.6)">
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(217 11661.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(241 11661.083)" fill="#77be7e" />
                        </g>
                        <text transform="translate(218 10895.483)" font-size="14" fontFamily="Roboto Condensed, sans-serif, Roboto">
                            <tspan x="-60.71" y="0">Roaches: 2</tspan>
                        </text>
                    </g>
                    <g transform="translate(0 15.517)">
                        <g transform="translate(-121 -778.6)">
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(313 11636.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(337 11636.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(265 11636.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(361 11636.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(289 11636.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(217 11636.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(241 11636.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(385 11636.083)" fill="#77be7e" />
                        </g>
                        <text transform="translate(233 10847.483)" font-size="14" fontFamily="Roboto Condensed, sans-serif, Roboto">
                            <tspan x="-89.927" y="0">Rainbow trout: 8</tspan>
                        </text>
                    </g>
                    <g transform="translate(0 14.517)">
                        <g transform="translate(91 -713.083)">
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(113 11521.566)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(137 11521.566)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(65 11521.566)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(161 11521.566)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(89 11521.566)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(17 11521.566)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(41 11521.566)" fill="#77be7e" />
                        </g>
                        <text transform="translate(261 10798.483)" font-size="14" fontFamily="Roboto Condensed, sans-serif, Roboto">
                            <tspan x="-147.376" y="0">Pacific salmon (generic): 7</tspan>
                        </text>
                    </g>
                    <g transform="translate(0 11.517)">
                        <g transform="translate(-61 -824.6)">
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(265 11586.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(217 11586.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(241 11586.083)" fill="#77be7e" />
                        </g>
                        <text transform="translate(285 10751.483)" font-size="14" fontFamily="Roboto Condensed, sans-serif, Roboto">
                            <tspan x="-194.872" y="0">Miscellaneous freshwater fishes: 3</tspan>
                        </text>
                    </g>
                    <g transform="translate(0 9.517)">
                        <g transform="translate(-49 -847.6)">
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(217 11561.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(241 11561.083)" fill="#77be7e" />
                        </g>
                        <text transform="translate(220 10703.483)" font-size="14" fontFamily="Roboto Condensed, sans-serif, Roboto">
                            <tspan x="-64.019" y="0">Mackerel: 2</tspan>
                        </text>
                    </g>
                    <g transform="translate(0 7.517)">
                        <g transform="translate(-157 -738.6)">
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(265 11404.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(361 11404.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(289 11404.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(217 11404.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(313 11404.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(241 11404.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(337 11404.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(433 11404.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(385 11404.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(457 11404.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(409 11404.083)" fill="#77be7e" />
                        </g>
                        <text transform="translate(221 10655.483)" font-size="14" fontFamily="Roboto Condensed, sans-serif, Roboto">
                            <tspan x="-67.307" y="0">Herrings: 11</tspan>
                        </text>
                    </g>
                    <g transform="translate(0 5.517)">
                        <g transform="translate(-49 -761.6)">
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(217 11379.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(241 11379.083)" fill="#77be7e" />
                        </g>
                        <text transform="translate(212 10607.483)" font-size="14" fontFamily="Roboto Condensed, sans-serif, Roboto">
                            <tspan x="-48.016" y="0">Hakes: 2</tspan>
                        </text>
                    </g>
                    <g transform="translate(0 5.517)">
                        <g transform="translate(-37 -786.6)">
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(217 11354.083)" fill="#77be7e" />
                        </g>
                        <text transform="translate(233 10557.483)" font-size="14" fontFamily="Roboto Condensed, sans-serif, Roboto">
                            <tspan x="-90.761" y="0">Common carp: 1</tspan>
                        </text>
                    </g>
                    <g transform="translate(0 3.517)">
                        <g transform="translate(163 -841.6)">
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(17 11361.083)" fill="#77be7e" />
                        </g>
                        <text transform="translate(226 10509.483)" font-size="14" fontFamily="Roboto Condensed, sans-serif, Roboto">
                            <tspan x="-77.438" y="0">Brown trout: 1</tspan>
                        </text>
                    </g>
                    <g transform="translate(0 1.517)">
                        <g transform="translate(151 -838.6)">
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(17 11310.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(41 11310.083)" fill="#77be7e" />
                        </g>
                        <text transform="translate(229 10461.483)" font-size="14" fontFamily="Roboto Condensed, sans-serif, Roboto">
                            <tspan x="-82.018" y="0">Silver bream: 2</tspan>
                        </text>
                    </g>
                    <g transform="translate(0 -0.483)">
                        <text transform="translate(235 10413.483)" font-size="14" fontFamily="Roboto Condensed, sans-serif, Roboto">
                            <tspan x="-94.11" y="0">Atlantic bonito: 2</tspan>
                        </text>
                        <g transform="translate(151 -835.6)">
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(17 11259.083)" fill="#77be7e" />
                            <circle cx="7.5" cy="7.5" r="7.5" transform="translate(41 11259.083)" fill="#77be7e" />
                        </g>
                    </g>
                </g>
            </svg>
        </Box>
    );

}


export default DottedGraphMobile;